export default __webpack_public_path__ + "static/media/scooter.93f77634.svg";